import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { OttPlanProvider } from "../contexts/OttPlanContext";
import { DialogProvider } from "../contexts/DialogContext";

export const OttPlanComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<OttPlanProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};
